//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import helpBanner from '~/components/help/helpBanner.vue' // 面包屑
import { matomofn } from '~/assets/js/utils.js'

export default {
  components: {
    'help-banner': helpBanner
  },
  layout (context) {
    return context.route.query?.type ? 'empty' : 'default'
  },
  async asyncData ({ $api, store, redirect, route }) {
    const { locale = 'en', countryCode } = store.state
    const id = route?.query?.id || 'vps_all'
    // 获取tab数据
    const res = await $api.common
      .v3Server(
        {
          Routes: 'wikifxarticle$vpsquerycat',
          BasicData: store.getters?.getDiffBasic
        },
        { languageCode: locale, countryCode }
      )
      .catch(() => {})
    console.log('res::: ', res)
    const tabs = res?.wikifxarticle?.vpsquerycat?.data || []
    tabs.forEach((item, index) => {
      item.name = item.content
      item.id = item.artCatId
      item.ind = index
    })

    const mobileIndex = tabs.find(item => item.artCatId === id).ind
    // 获取列表数据
    const res1 = await $api.common
      .v3Server(
        {
          Routes: 'wikifxarticle$vpsqueryartbycatid',
          BasicData: store.getters?.getDiffBasic
        },
        {
          languageCode: locale,
          countryCode,
          catId: id,
          pageIndex: 1,
          pageSize: 100
        }
      )
      .catch(() => {})
    const listData = res1?.wikifxarticle?.vpsqueryartbycatid?.data?.items || []
    return {
      tabs,
      listData,
      countryCode,
      locale,
      active: store?.state?.isMobile ? mobileIndex : id
    }
  },
  data () {
    return {
      isApp: this.$route.query?.type || 0,
      listData: [], // 列表数据
      tabs: [], // tab数据
      active: 0, // 当前tab选中
      pageEnterTime: null // 页面进入时间
    }
  },
  computed: {
    // 是否为移动端
    isM () {
      return this.$store?.state?.isMobile
    }
  },
  mounted () {
    // 记录页面进入时间
    this.pageEnterTime = Date.now()
    // 监听页面关闭事件
    window.addEventListener('beforeunload', this.trackPageTime)
    // 移动端将当前激活的tab滚动到视图居中位置
    if (this.isM && this.tabs.length > 0) {
      this.$nextTick(() => {
        // 找到当前激活的tab索引
        const activeIndex = this.tabs.findIndex(item =>
          this.isM ? item.ind === this.active : item.id === this.active
        )
        const activeTab = this.$refs.mTabs?.children[activeIndex]
        if (activeTab) {
          activeTab.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',
            inline: 'center'
          })
        }
      })
    }
    // console.log(this.tabs, 'resres') // tab数据
    // console.log(this.listData, 'listData') // 列表数据
  },
  beforeDestroy () {
    // 移除事件监听器
    window.removeEventListener('beforeunload', this.trackPageTime)
    // 执行页面时间统计
    this.trackPageTime()
  },
  methods: {
    // 页面时间统计
    trackPageTime () {
      if (this.pageEnterTime) {
        const exitTime = Date.now()
        matomofn(
          'Cloud_Help_Time',
          {
            af_Enter: this.pageEnterTime,
            af_Exit: exitTime
          },
          this.$store.state,
          this.$cookies
        )
      }
    },
    // h5tab点击方法
    tabClick (ind, id) {
      if (this.active == id) return false
      window.open(`/${this.locale}/help/help-list.html?id=${id}`)
      // this.active = id
      // if (this.isM) {
      //   this.$refs.mTabs?.children?.[this.active].scrollIntoView({
      //     behavior: 'smooth',
      //     block: 'nearest',
      //     inline: 'center'
      //   })
      // }
      // // this.$router.replace({ path: '/zh-cn/help/help-list.html', query: { id } })
      // const res1 = await this.$api.common.v3Client({ Routes: 'wikifxarticle$vpsqueryartbycatid', BasicData: this.$store.getters?.getDiffBasic }, { languageCode: this.locale, countryCode: this.countryCode, catId: id, pageIndex: 1, pageSize: 100 }).catch(() => {})
      // const arr = res1?.wikifxarticle?.vpsqueryartbycatid?.data?.items || []
      // if (arr.length) {
      //   arr.forEach((item, index) => {
      //     item.name = item.content
      //     item.id = item.artCatId
      //     item.ind = index
      //   })
      // }
      // this.listData = arr
      // const scorllTop = document.querySelector('.help-banner')?.offsetHeight || 360
      // // this.$router.replace({ path: '/zh-cn/help/help-list.html', query: { id } })
      // // console.log(scorllTop, this.$refs.contentLeft)
      // if (!this.isM) {
      //   window?.scrollTo({ top: scorllTop, behavior: 'instant' })
      // }
    }
  }
}
